module.exports = __webpack_public_path__ + "images/newerp_logo_w.1789440611829.png";